import {
  ContactModel,
  PhoneTypes,
  createPhoneNumber,
} from '@akin-home/contacts';
import produce from 'immer';
import { useCallback } from 'react';
import { useUpdateFieldsCommand } from '../../chat/hooks';

export const useUpdateContactFormListener = (
  setContact: React.Dispatch<React.SetStateAction<ContactModel | undefined>>
) =>
  useUpdateFieldsCommand(
    useCallback((data: any) => {
      setContact(
        produce((contact) => {
          if (!contact) return;

          if (data.name) {
            contact.name = data.name;
          }

          if (data.email) {
            if (contact.emailAddresses.length) {
              contact.emailAddresses[0] = data.email;
            } else {
              contact.emailAddresses = [data.email];
            }
          }

          if (data.phone_number) {
            if (contact.phoneNumbers.length) {
              contact.phoneNumbers[0].number = data.phone_number;
            } else {
              contact.phoneNumbers[0] = createPhoneNumber({
                type: PhoneTypes.Mobile,
                number: data.phone_number,
              });
            }
          }
        })
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  );
